<template>
	<div class="d3-blood-saturation">
		<svg :width="width" :heigth="height">
			<circle class="back" :cx="circle.cx" :cy="circle.cy" :r="circle.r"/>
			<circle class="front" :cx="circle_value.cx" :cy="circle_value.cy" :r="circle_value.r"/>
		</svg>
		<div class="display">
			<div><span class="value">{{ value }}</span>%</div>
			<div>spO<sub>2</sub></div>
		</div>
	</div>
</template>

<script>
import * as d3 from '@/utils/d3'
export default {
	props: [
		'value'
	],
	data () {
		return {
			margin: 20,
			width: 0,
			height: 0
		}
	},
	computed: {
		padded () {
			const width = Math.max(this.width - this.margin * 2, 0)
			const height = Math.max(this.height - this.margin * 2, 0)
			return { width, height }
		},
		scale () {
			return d3.scaleLinear()
				.domain([0, 100])
				.range([0, Math.min(this.padded.width, this.padded.height)])
		},
		scaled_value () {
			return this.scale(this.value)
		},
		circle () {
			var cx = this.width / 2
			var cy = this.height / 2
			var r = Math.min(this.padded.width / 2, this.padded.height / 2)
			return { cx, cy, r }
		},
		circle_value () {
			var cx = this.circle.cx
			var r = Math.max(this.scaled_value / 2, 0)
			var cy = this.circle.cy + (this.circle.r - r)
			return { cx, cy, r }
		}
	},
	methods: {
		onResize () {
			//console.log('D3BloodSaturation.onResize')
			this.width = Math.max(this.$el.offsetWidth, 0)
			this.height = Math.max(this.$el.offsetHeight, 0)
		}
	},
	mounted () {
		window.addEventListener('resize', this.onResize)
		this.$root.$on('force-render-biometric-measure', this.onResize)
		this.onResize()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onResize)
		this.$root.$off('force-render-biometric-measure', this.onResize)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/D3BloodSaturation.vue